import { Image } from "./image";
import React from "react";

export const Mapa = (props) => {
  return (
    <div id="mapa" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Departamentos donde estamos presentes</h2>
          <img src="img/mapaC.svg" className="img-responsive " alt="" />{" "}
        </div>

      </div>
    </div>
  );
};
